"use client"

import { LazyMotion, domAnimation, m } from "framer-motion"

import { cn } from "@/lib/utils"

export default function LoadingSpinner({
  className,
  variant = "classic",
}: {
  className?: string
  variant?: "classic" | "orbiting"
}) {
  return (
    <>
      {variant === "classic" && (
        <div
          className={cn(
            "border-primary/20 border-t-primary size-10 animate-spin rounded-full border-4",
            className,
          )}
        />
      )}
      {variant === "orbiting" && (
        <LazyMotion features={domAnimation}>
          <div className={cn("relative", className)}>
            {[...Array(8)].map((_, index) => {
              const angle = (index / 8) * (2 * Math.PI)
              const x = 20 * Math.cos(angle)
              const y = 20 * Math.sin(angle)

              return (
                <m.div
                  key={index}
                  className="bg-primary absolute h-3 w-3 rounded-full"
                  style={{
                    left: `calc(50% + ${x}px)`,
                    top: `calc(50% + ${y}px)`,
                  }}
                  animate={{
                    scale: [0, 1, 0],
                    opacity: [0, 1, 0],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    delay: (index / 8) * 1.5,
                    ease: "easeInOut",
                  }}
                />
              )
            })}
          </div>
        </LazyMotion>
      )}
    </>
  )
}
